// extracted by mini-css-extract-plugin
export default {"premiumLayoutWrapper":"App_premiumLayoutWrapper__30dnc"};